<template>
  <v-card outlined class="pa-5">
    <table-toolbar
      hide-delete
      :search="search"
      @update:search="(e) => (search = e)"
      @refresh="loadRecentOrders()"
    />

    <recent-orders-table
      :items="unprocessedRecentOrders"
      :search="search"
      :loading="loadingRecentOrders"
      :hide-headers="headersToHide"
      :selected-order-id="selectedOrderId"
      hide-export
      @onSelect="selectOrder"
    >
      <template #footer-append>
        <v-btn class="green-button w-xs-100" @click="goToRecentOrders">
          Ir a carritos
        </v-btn>
      </template>
    </recent-orders-table>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { Channels } from '@/core/constants/channelConstants';
  import { Roles } from '@/core/constants/roleConstants';
  import Policies from '@/core/policies';

  import numbersFormats from '@/mixins/numbersFormats';
  import RecentOrdersTable from '@/components/tables/RecentOrdersTable.vue';
  import TableToolbar from '@/components/tables/TableToolbar.vue';

  export default {
    name: 'RecentOrders',

    components: {
      RecentOrdersTable,
      TableToolbar,
    },
    mixins: [numbersFormats],
    data() {
      return {
        search: '',
        deleteActionEnabled: false,
        deleteOrderData: null,
        showDeleteConfirmation: false,
      };
    },
    computed: {
      ...mapGetters('recentOrders', [
        'loadingRecentOrders',
        'unprocessedRecentOrders',
        'selectedRecentOrder',
        'recentOrdersMutuationError',
      ]),

      ...mapGetters('auth', ['channel', 'mainRole']),

      selectedOrderId() {
        return this.selectedRecentOrder?.id || null;
      },

      headersToHide() {
        const columns = !Policies.OrderPolicy.canCreate() ? ['select'] : [];

        switch (this.mainRole.name) {
          case Roles.CUSTOMER_WHOLESALER:
          case Roles.CUSTOMER_RETAIL:
            columns.push(
              'status',
              'updatedAt',
              'processedAt',
              'customer',
              'seller',
              'manager',
              'regionalManager',
              'director',
              'subdirector'
            );
            break;
          default:
            columns.push(
              'status',
              'updatedAt',
              'processedAt',
              'seller',
              'manager',
              'regionalManager',
              'director',
              'subdirector'
            );
            break;
        }

        return columns;
      },
    },
    methods: {
      ...mapActions('recentOrders', [
        'setRecentOrderSelected',
        'loadRecentOrders',
      ]),

      ...mapActions('loader', ['activeLoader', 'desactiveLoader']),

      async selectOrder(order) {
        this.activeLoader();
        this.$emit('onSelectItem');
        await this.setRecentOrderSelected(order.id);

        if (this.recentOrdersMutuationError) {
          // Only deactivate the loader if there's an error.
          // If we're already on the cart view, it's observing the selectedOrder.
          // When the selected order changes, the cart automatically refreshes its data
          // and activates the same shared loader.
          // If we deactivate the loader here before the cart finishes loading,
          // we may prematurely stop the loader the cart just started.
          this.$toast.error(this.recentOrdersMutuationError);
          this.desactiveLoader();
        } else {
          this.navigateToOrderCart(order);
        }
      },

      goToRecentOrders() {
        this.$emit('closeModal');

        if (this.$route.name !== 'recentOrders') {
          this.$router.push({ name: 'recentOrders' });
        }
      },

      navigateToOrderCart(order) {
        let to = null;

        if (this.channel === Channels.WHOLESALER) {
          to = this.$router.resolve({
            name: 'NewShoppingCartPR',
            params: { doctype: order.doctype, idq: 0 },
          });
        } else {
          to = this.$router.resolve({
            name: 'NewShoppingCart',
            params: { doctype: order.doctype, idq: 0 },
          });
        }

        // Avoids NavigationDuplicated error
        if (this.$route.fullPath !== to.route.fullPath) {
          this.$router.push(to.route);
        }
      },
    },
  };
</script>
